import NavLink from '@theme/components/NavLink.vue';
import DropdownTransition from '@theme/components/DropdownTransition.vue';
import last from 'lodash/last';
export default {
  components: {
    NavLink,
    DropdownTransition
  },
  data() {
    return {
      open: false,
      isMQMobile: false
    };
  },
  props: {
    item: {
      required: true
    }
  },
  computed: {
    dropdownAriaLabel() {
      return this.item.ariaLabel || this.item.text;
    }
  },
  beforeMount() {
    this.isMQMobile = window.innerWidth < 720 ? true : false;
    window.addEventListener('resize', () => {
      this.isMQMobile = window.innerWidth < 720 ? true : false;
    });
  },
  methods: {
    toggle() {
      if (this.isMQMobile) {
        this.open = !this.open;
      }
    },
    isLastItemOfArray(item, array) {
      return last(array) === item;
    }
  },
  watch: {
    $route() {
      this.open = false;
    }
  }
};